"use strict";

document.documentElement.classList.add("js");
document.documentElement.classList.remove("no-js");

import styles from "./css/main.css";
// import "font-awesome/css/font-awesome.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import "./vendor/fontawesome-pro-5.2.0/css/all.css";
// import "./vendor/fontawesome-pro-5.2.0/css/svg-with-js.css";

import "./js/menu.js";
import "./js/accordion.js";
import "./js/carousel.js";
import "./js/modal.js";
// import "./js/form.js";
import "./js/custom.js";



// WEBPACK FOOTER //
// ./app.js